import styled, { keyframes } from 'styled-components';
import { RotateAnimProps } from '../common/types';

const continuousRotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  
  100% {
    transform: rotate(360deg);
  }
`;

const RotatingTiltedIcon = styled.div<RotateAnimProps>`
   animation: ${continuousRotation} ${({ $duration }) => $duration || '6s'} linear infinite;
  transform-origin: center;
`;

const RotatingTiltedIconWrapper : React.FC<RotateAnimProps> = ({ children, $duration }) => {
  return <RotatingTiltedIcon $duration={$duration}>{ children }</RotatingTiltedIcon>;
};

export default RotatingTiltedIconWrapper ;


//    50% {
  //   transform: rotate(20deg); /* Rotate to the extreme */
  // }